export enum AP3UserManagementRoutePathNames {
  AP3_USERS = 'admin-panel-users',
  LIST = '',
  ID = ':id',
  CREATE = 'create',
}
